import { forwardRef } from 'react';
import NumberFormat from 'react-number-format';
import FormField from './FormField';
import { controlClasses } from './controlClasses';

type Props = {
  label?: string;
  id?: string;
  name?: string;
  value?: string;
  /** Receives raw digits, not the formatted string. */
  onChange?: (digits: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
};

/**
 * react-number-format rather than a hand-rolled mask. The formatting is trivial; keeping
 * the caret in the right place when someone edits the middle of the number is not, and
 * that is the part a hand-rolled version gets wrong. It costs a few KB in the bundle,
 * which is the right trade on a form that collects sales leads.
 */
const FormInputPhone = forwardRef<HTMLInputElement, Props>(
  ({ label, id, name, value, onChange, onBlur, placeholder, disabled, error }, ref) => (
    <FormField id={id} label={label} error={error}>
      <NumberFormat
        id={id}
        name={name}
        format="(###) ###-####"
        mask="_"
        value={value}
        onValueChange={(values) => onChange?.(values.value)}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        getInputRef={ref}
        aria-invalid={error ? true : undefined}
        aria-describedby={error && id ? `${id}-error` : undefined}
        className={controlClasses(!!error)}
      />
    </FormField>
  )
);

FormInputPhone.displayName = 'FormInputPhone';

export default FormInputPhone;
